<!--
@Author: DKing
@Desc: 解决方案-地产行业
@Date: 2021-04-22
-->
<template>
  <div>
    <div class="banner-box">
      <p class="title">房地产行业解决方案</p>
      <p class="btnFullColor" @click="jumpPage">立即咨询</p>
    </div>

    <div class="min-width-pc">
      <div class="title-txt">环境预见</div>
      <div class="section-hyhj">
        <!-- 行业大环境 -->
        <div class="section-item first" :class="activeClassName == 'first' ? 'active':'unactive'">
        <!-- <div class="section-item first"> -->
          <div class="left-img" @mouseenter="mouseenterFn('first')">
            <div class="unactive-item">
              <div class="bg-modal"></div>
              <div class="content">
                <span>行业大环境</span>
                <span class="el-icon-right"></span>
              </div>
            </div>

            <div class="active-item">
              <span class="title">行业大环境</span>
              <img src="./../../../static/pc/解决方案/icon_solutiong_yujian.png" alt="">
              <p class="txt">未来房地产总数量规模会被控制在一个很小的范围</p>
            </div>

          </div>
          <div class="content-box">
            <p class="title">房企</p>
            <div class="text-content">
              <p class=txt-item>
                TOP5的房企销售金额占总体规模市场约15%，TOP30房企占比约35%，且逐年递增（TOP5车企51%；空调品牌78%；手机品牌83%） 
              </p>
              <p class=txt-item>
                未来房企数量较大概率会控制在较小范围
              </p>
              <p class=txt-item>
                头部房企未来会进一步抢占腰部及以下房企的市场份额
              </p>
              <p class=txt-item>
                过去企业依赖大幅度增加负债的增长模式在未来生存空间会越来越小。加快去化，加快销售变现，降低企业负债率会成为主流
              </p>
            </div>
            <p class="slider"></p>
            <p class="title">销售</p>
            <div class="text-content">
              <p class=txt-item>
                市场上多个熟知的销售渠道在若干年与企业合作过程中逐年迅速发展壮大，当年屠龙的少年在很多房企老板眼里已经变成了“恶龙” 
              </p>
              <p class=txt-item>
                部分房企的销售渠道被第三方完全掌控，而企业也是饮鸩止渴，恶性循环导致企业自己的话语权逐年减弱。企业营销预算被第三方全部拿走，也导致企业本身的营销能力越来越弱
              </p>
            </div>
          </div>
        </div>

        <!-- 企业环境 -->
        <div class="section-item second" :class="activeClassName == 'second' ? 'active':'unactive'">
        <!-- <div class="section-item second"> -->
          <div class="left-img">
            <div class="unactive-item" @mouseenter="mouseenterFn('second')">
              <div class="bg-modal"></div>
              <div class="content">
                <span>企业环境</span>
                <span class="el-icon-right"></span>
              </div>
            </div>

            <div class="active-item">
              <span class="title">企业环境</span>
              <img src="./../../../static/pc/解决方案/icon_solutiong_yujian.png" alt="">
              <p class="txt">在未来争存量白热化的市场环境下，完全依赖第三方包销渠道的部分房企项目如果为了争抢当地固定存量市场客户，第三方渠道收费方式和收费费率也必然进一步水涨船高</p>
            </div>

          </div>
          <div class="content-box">
            <p class="title">政策</p>
            <div class="text-content">
              <p class=txt-item>
                中国房地产行业从2019年进入分水岭，中央调控政策，房地产总体规模会保持很多年，不会有明显增量 
              </p>
              <p class=txt-item>
                房企从过去抢增量市场到明年开始争存量市场
              </p>
              <p class=txt-item>
                2020年年中，中央出台“三道红线” ，以及12月31日央行出台的“银行金融机构房地产贷款集中管理”等调控新规，使分水岭更加具象化
              </p>
              <p class=txt-item>
                过去企业依赖大幅度增加负债的增长模式在未来生存空间会越来越小。加快去化，加快销售变现，降低企业负债率会成为主流
              </p>
            </div>
            <p class="slider"></p>
            <p class="title">行业</p>
            <div class="text-content">
              <p class=txt-item>
                平均目标增长率由 2018 年的 41% 回落至 20% ，去化率不及预期 
              </p>
              <p class=txt-item>
                受调控持续、市场整体去化率不及预期，房企的目标完成率呈逐年降低的态势。相比2016年、2017年近80%房企目标完成率超110%，2019年该区间的房企数量明显降低，全年仅50%房企目标完成率集中在100%-110% 之间
              </p>
              <p class=txt-item>
                2020年top30房企，仅8成完成年度目标
              </p>
            </div>
          </div>
        </div>
        
      </div>

      <div class="title-txt">房地产行业解决方案</div>
      <div class="section2">
        <div class="text-content">
          <div class="title">
            全民营销服务+灵活用工模式
          </div>
          <p class=txt-item>
            慧用工作为新业态新经济灵活用工平台，与地产企业建立平台综合服务协议，给企业提供全民营销服务
          </p>
          <p class=txt-item>
            慧用工与企业内外的地产经济人签署相应的电子服务合同，帮助企业销售
          </p>
          <p class=txt-item>
            慧用工为企业提供票据凭证
          </p>
          <p class=txt-item>
            地产经济人的服务佣金，由慧用工平台统一发放，统一申报个税
          </p>
        </div>
        <img class="text-img" src="./../../../static/pc/解决方案/img_solution_31@2x.png" alt="">

      </div>
    </div>

    <div class="section-ys">
      <div class="min-width-pc">
        <div class="aside aside-left">
          <!-- 营销赋能 -->
          <div class="item item1">
            <p class="title">营销赋能</p>
            <p class=txt>
              项目地域所在地私域流量传播-饱和式覆盖所有人群
            </p>
            <p class=txt>
              完全可视化营销费用支出-精确到人的树状传播结构
            </p>
            <p class=txt>
              企业自己的销售渠道-企业能完全掌控
            </p>
            <p class=txt>
              全民营销平台下的个人分佣比例最大
            </p>
            <div class="arrow"></div>
          </div>

          <div class="item item2">
            <p class="title">合法合规</p>
            <p class=txt>
              严格遵循国家法律法规，按 规代征个人税收；平台业务链条完整合规，四流一致-饱和式覆盖所有人群
            </p>
            <div class="arrow"></div>
          </div>

        </div>
        <div class="center"></div>
        <div class="aside aside-right">
          <div class="item item3">
            <p class="title">成本优化</p>
            <p class=txt>
              降低企业运营管理成本，降低企业雇佣模式下用工风险及成本，提高个人收入-饱和式覆盖所有人群
            </p>
            <div class="arrow"></div>
          </div>

          <div class="item item4">
            <p class="title">简单高效</p>
            <p class=txt>
              智能结算saas系统，全程线上办理，操作简单，提高企业管理效率，降低人工出错概率，降低HR及财务工作量
            </p>
            <div class="arrow"></div>
          </div>

          <div class="item item5">
            <p class="title">资金安全</p>
            <p class=txt>
              我们与招商及网商银行建立合作，共管账户、专款专用、秒级结算到账（可结算至个人银行账户、微信钱包余额、支付宝账户），保障客户的资金安全
            </p>
            <div class="arrow"></div>
          </div>
        </div>
      </div>

      <p>助力营销赋能，加快销售回款；回归真实业务，降低企业成本。</p>
    </div>

    <div class="min-width-pc">
      <div class="title-txt">合作案例</div>
      <div class="section-hzal">
        <div class="text-content">
          <div class="title">
            长隆、景盛、坤达地产
          </div>
          <p class=txt-item>
            <span class="small-title">降低财务风险</span> 
            企业进行全民营销活动，帮助企业给个人结算的佣金实现账务合规，有增值税专用 发票可抵扣。 
          </p>
          <p class=txt-item>
            <span class="small-title">降低企业成本8%</span> 
            全民营销模式+慧用工解决方案，降低企业用工成本。每月为企业节省单人4900元用工成本，节省8%的用工成本 
          </p>
          <p class=txt-item>
            <span class="small-title">个人收入提升33%</span> 
            单个项目为个人提高收入1万余元左右
          </p>
        </div>
        <img class="text-img" style="width:485px; height:337px;" src="./../../../static/pc/解决方案/img_solution_case@2x.png" alt="">

      </div>
    </div>

    <!-- 弹窗form -->
    <pc-form-dialog :source='source'><span class="pc-form-text">慧用工｜致力于助力每一个优秀的公司</span></pc-form-dialog>
    <!-- 底部悬浮框 -->
    <pc-suspension-dialog :source="sourceF"></pc-suspension-dialog>

  </div>
</template>

<script type="text/javascript">
import pcFormDialog from '../../components/pcFormDialog.vue'
import pcSuspensionDialog from "../../components/pcSuspensionDialog";

export default {
  name: "solution-property",
  data() {
    return {
      activeClassName:'first',
      source: '',
      sourceF: '',

    }
  },
  
  components: {
    "pc-form-dialog": pcFormDialog,
    "pc-suspension-dialog": pcSuspensionDialog
  },
  
  created() {
     // source来源：：
    let hash = window.location.hash;
    this.source = hash.indexOf('source') > 0 ? hash.substring(hash.indexOf('source')) + '&pageFrom=jjfa_dchy' : '&pageFrom=jjfa_dchy';
    this.sourceF = this.source + "_f";
  },

  methods: {
    mouseenterFn(className){
      this.activeClassName = className;

      let firstDom = document.querySelector('.first .content-box')
      let secondDom = document.querySelector('.second .content-box')

      if(className == 'first'){
        console.log('1::',firstDom)
        firstDom.style.width = '720px'
        secondDom.style.width = '0px'

        firstDom.style.opacity = '1'
        secondDom.style.opacity = '0'

        firstDom.style.transition = 'all 0.4s'

      } else if(className == 'second'){
        console.log('2::',secondDom)
        secondDom.style.width = '720px'
        firstDom.style.width = '0px'

        secondDom.style.opacity = '1'
        firstDom.style.opacity = '0'

        secondDom.style.transition = 'all 0.4s'
      }
    },

    jumpPage(){
      eventBus.$emit("pcOperaDiaLog", true);
    },
  }
}
</script>

<style lang="scss" scoped>
.banner-box{
  background:url('./../../../static/pc/解决方案/banner_solution_3.png') no-repeat;
  background-color: #100f0f;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction:column;
}
.title-txt{
  margin-top:88px;
}
.section-hyhj{
  width: 100%;
  height: 540px;
  margin-top:88px;
  display: flex;
  box-shadow: 0px 20px 60px -20px rgba(0, 0, 0, 0.1);
  .section-item {
    width:auto;
    display: inline-flex;
    .content-box{
      width:720px;
      height: 100%;
      position:relative;
      text-align: left;
      overflow: hidden;
      &::after{
        position:absolute;
        left:-14px;
        top:calc(50% - 14px);
        content: '';
        background:url('./../../../static/pc/解决方案/icon_solution_jiantou@2x.png') no-repeat;
        background-size: 50%;
        width:28px;
        height: 28px;
      }
      .title{
        color: rgba(16, 15, 15, 100);
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 18px;
        padding-top:32px;
        padding-left:40px;
      }
      .text-content{
        padding:0;
        padding-left: 40px;
      }
      .slider{
        width: 100%;
        height: 1px;
        border-bottom:1px solid #cfcfcf;
        padding-top:20px;
      }
    }
    .left-img{
      height: 540px;
      width:240px;
      position: relative;
      background-size: 100%;
      .unactive-item{
        .bg-modal{
          position: absolute;
          width:100%;
          height: 100%;
          left:0;
          top:0;
          background-color: #002979;
          opacity: 0.8;
          z-index: 1;
        }
        .content{
          position: absolute;
          width:100%;
          height: 100%;
          line-height: 50px;
          left:0;
          top:0;
          z-index: 10;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          color: rgb(255, 255, 255);
          font-size: 24px;
          font-weight: bold;
        }
      }
      .active-item{
        display: flex;
        align-items: center;
        flex-direction: column;
        color: rgb(255, 255, 255);
        height: 100%;
        padding:84px 25px 0 25px;
        .title{
          // font-family: AlibabaPuHuiTiM;
          font-size: 24px;
          color: #FFFFFF;
          margin-bottom: 37px;
          font-weight: bold;
        }
        img{
          width:34px;
          height: 80px;
          margin-bottom: 57px;
        }
        .txt{
          font-size: 14px;
          color: #FFFFFF;
          line-height: 25px;
          text-align: left;
        }

      }
    }
  }
  
  .active{
    .left-img .unactive-item{
      display: none;
    }
    .left-img .active-item{
      display: flex;
    }
    .content-box .txt-item{
      opacity: 1;
      transition: all 0.8;
    }
  }
  .unactive{
    .left-img .unactive-item{
      display: block;
    }
    .left-img .active-item{
      display: none;
    }
    .content-box .txt-item{
      opacity: 0;
      transition: all 0.8;
    }
  }
  
  .first{
    .left-img{
      background-image: url('./../../../static/pc/解决方案/img_solution_hangye2.png');
    }
  }
  .second{
    .left-img{
      background-image: url('./../../../static/pc/解决方案/img_solution_qiye2.png');
    }
    .content-box{
      width: 0;
      opacity: 0;
    }
  }
}

.section2{
  display: flex;
  justify-content: space-between;
  margin-top:77px;
  margin-bottom: 88px;
  .text-content{
    width:370px;
  }
  img{
  }
}

.section-ys{
  width:100%;
  height: 700px;
  background-color: rgba(23, 30, 46, 1);
  color: rgba(255, 255, 255, 100);
  font-size: 24px;
  .min-width-pc{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 50px;
    height: 560px;
    .aside{
      color: rgba(255, 255, 255, 100);
      font-size: 14px;
      text-align: center;
      position: relative;
      .item{
        text-align: left;
        background-color: rgba(25, 133, 255, 1);
        box-shadow: 0px 20px 40px 0px rgba(0, 0, 0, 0.06);
        padding:20px;
        width: 300px;
        position: absolute;
        .title{
          font-size: 18px;
          font-weight: 500;
          margin-bottom: 11px;
        }
        .txt{
          line-height: 20px;
          margin-bottom:15px;
          position: relative;
          padding-left:22px;
          &::after{
            position: absolute;
            top:0;
            left:0;
            content: '';
            width: 18px;
            height: 18px;
            background: url('./../../../static/pc/解决方案/icon_sign_white.png') no-repeat;
            background-size: 100%;
          }
        }
        .arrow{
          position: absolute;
          right:-200px;
          top:30px;
          width:160px;
          height: 57px;
          border-top:1px dotted #1985FF;
          &::after{
            content: '';
            display: block;
            width: 60px;
            height: 60px;
            border-top:1px dotted #1985FF;
            transform: rotate(45deg);
            position: absolute;
            right: -30px;
            top: 12px;
          }
        }
      }
      .item1{
        height: 261px;
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        padding-right:0;
        top: -170px;
        left: -475px;
        &:hover{
          top:-175px;
          -webkit-transition: all 0.2s;
          -moz-transition: all 0.2s;
          -ms-transition: all 0.2s;
          -o-transition: all 0.2s;
          transition: all 0.2s;
        }
        &::after{
          content: '';
          display: inline-block;
          width: 43px;
          height: 261px;
          position: absolute;
          top:0;
          right: -42px;
          background:url('./../../../static/pc/解决方案/img_youshi_bg1.png') no-repeat;
          background-size: 100%;
        }
      }

      .item2{
        height: 128px;
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        padding-right:0;
        top: 110px;
        left: -475px;
         &:hover{
          top:105px;
          -webkit-transition: all 0.2s;
          -moz-transition: all 0.2s;
          -ms-transition: all 0.2s;
          -o-transition: all 0.2s;
          transition: all 0.2s;
        }
        &::after{
          content: '';
          display: inline-block;
          width: 43px;
          height: 261px;
          position: absolute;
          top:0;
          right: -42px;
          background:url('./../../../static/pc/解决方案/img_youshi_bg2.png') no-repeat;
          background-size: 100%;
        }
        .arrow{
          top:33px;
          &::after{
            content: '';
            display: block;
            width: 60px;
            height: 60px;
            border:none;
            border-right:1px dotted #1985FF;
            transform: rotate(45deg);
            position: absolute;
            right: -30px;
            top: -73px;
          }
        }
      }

      .item3{
        height: 125px;
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
        padding-left:0;
        top: -200px;
        right: -475px;
        &:hover{
          top:-190px;
          -webkit-transition: all 0.2s;
          -moz-transition: all 0.2s;
          -ms-transition: all 0.2s;
          -o-transition: all 0.2s;
          transition: all 0.2s;
        }
        &::after{
          content: '';
          display: inline-block;
          width: 43px;
          height: 261px;
          position: absolute;
          top:0;
          left: -42px;
          background:url('./../../../static/pc/解决方案/img_youshi_bg3.png') no-repeat;
          background-size: 100%;
        }
        .arrow{
          top:33px;
          left:-160px;
          &::after{
            content: '';
            display: block;
            width: 60px;
            height:104px;
            border:none;
            border-left:1px dotted #1985FF;
            transform: rotate(45deg);
            position: absolute;
            left: -47px;
            top:6px;
          }
        }

      }

      .item4{
        height: 125px;
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
        padding-left:0;
        top: -50px;
        right: -475px;
        &:hover{
          top:-55px;
          -webkit-transition: all 0.2s;
          -moz-transition: all 0.2s;
          -ms-transition: all 0.2s;
          -o-transition: all 0.2s;
          transition: all 0.2s;
        }
        &::after{
          content: '';
          display: inline-block;
          width: 43px;
          height: 261px;
          position: absolute;
          top:0;
          left: -42px;
          background:url('./../../../static/pc/解决方案/img_youshi_bg3.png') no-repeat;
          background-size: 100%;
        }
        .arrow{
          top:33px;
          left:-146px;
          width:110px;
          &::after{
            content: '';
            display: block;
            width: 60px;
            height:80px;
            border:none;
            border-left:1px dotted #1985FF;
            transform: rotate(45deg);
            position: absolute;
            left: -39px;
            top:10px;
          }
        }
      }

      .item5{
        height: 168px;
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
        padding-left:0;
        top: 94px;
        right: -475px;
        &:hover{
          top:99px;
          -webkit-transition: all 0.2s;
          -moz-transition: all 0.2s;
          -ms-transition: all 0.2s;
          -o-transition: all 0.2s;
          transition: all 0.2s;
        }
        &::after{
          content: '';
          display: inline-block;
          width: 43px;
          height: 261px;
          position: absolute;
          top:0;
          left: -42px;
          background:url('./../../../static/pc/解决方案/img_youshi_bg5.png') no-repeat;
          background-size: 100%;
        }
        .arrow{
          top:33px;
          left:-201px;
          width:160px;
          &::after{
            content: '';
            display: block;
            width: 60px;
            height:80px;
            border:none;
            border-bottom:1px dotted #1985FF;
            // border-top:1px solid blue;
            // border-bottom:1px solid red;
            // border-right: 1px solid yellow;
            // border-left: 1px solid green;
            transform: rotate(45deg);
            position: absolute;
            left: -22px;
            top:-91px;
          }
        }
      }
    }

    .center{
      width:246px;
      height: 246px;
      border-radius: 50%;
      background-color: rgba(37, 86, 141, 0.7);
      box-shadow: 0px 20px 60px -20px rgba(0, 0, 0, 0.1);
      display: inline-block;
      position: relative;
      color: rgba(255, 255, 255, 100);
      font-size: 36px;
      z-index: 10;
      &::after{
        width:214px;
        height: 214px;
        border-radius: 50%;
        background-color: rgba(25, 133, 255, 0.9);
        box-shadow: 0px 20px 60px -20px rgba(0, 0, 0, 0.1);
        content: '我们的\A优势';
        white-space: pre;
        display: inline-flex;
        justify-content: center;
        align-items:center;
        position: absolute;
        top:16px;
        left:16px;
        text-align: center;
        z-index: 1;
      }
      &:hover{
        transform: scale(1.03);
        // -webkit-transition: all 0.6s;
        // -moz-transition: all 0.6s;
        // -ms-transition: all 0.6s;
        // -o-transition: all 0.6s;
        transition: all 0.6s;
        background-color: rgba(37, 86, 141, 1);
      }
      &:hover::after{
        background-color: rgba(25, 133, 255, 1);
      }
    }

    
  }
}

.section-hzal{
  display: flex;
  background-color: #fff;
  box-shadow: 0px 20px 60px -20px rgba(0, 0, 0, 0.1);
  width: 100%;
  margin-bottom: 88px;
  margin-top:77px;
  padding:32px 17px 32px 90px;
  justify-content: center;
  align-items: center;
}
.text-content{
  padding-top: 69px;
  padding-bottom:36px;
  widows: 305px;
  text-align: left;
  box-sizing: border-box;
  .title{
    color: rgba(64, 63, 63, 100);
    font-size: 24px;
    // font-family: AlibabaPuHuiTiM;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .txt-item{
    line-height: 20px;
    color: rgba(64, 63, 63, 100);
    font-size: 14px;
    margin-bottom:15px;
    position: relative;
    padding-left:30px;
    padding-right:70px;
    .small-title{
      color:#403F3F;
      display: block;
      margin-bottom:10px;
      // font-family: AlibabaPuHuiTiM;
      font-weight: 500;
    }
    &::after{
      position: absolute;
      top:0;
      left:0;
      content: '';
      width: 18px;
      height: 18px;
      background: url('./../../../static/pc/解决方案/icon_sign_blue.png') no-repeat;
      background-size: 100%;
    }
  }
}
.text-img{
  width: 805px;
  height: 400px;
}

</style>


// WEBPACK FOOTER //
// src/views/pc/solution_property.vue